// 直销订单列表
<template>
    <div>
        <van-sticky>
            <van-nav-bar
                title="我的订单"
                left-text="返回"
                left-arrow
                @click-left="goback"/>
            <van-tabs @click="tabclick">
                <van-tab title="所有" name="100"></van-tab>
                <van-tab title="待支付" name="0"></van-tab>
                <van-tab title="待处理" name="124"></van-tab>
                <van-tab title="已完成" name="3"></van-tab>
            </van-tabs>
        </van-sticky>
        <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad">
            <OrderItem
                v-for="item in data"
                :key=item.id
                :item="item"
                @pick="goDetail"/>
        </van-list>
    </div>
</template>

<script>
import { 
    NavBar, 
    Card, 
    Tabs, 
    Tab, 
    Icon, 
    Loading, 
    List,
    Sticky
} from 'vant'
import OrderItem from '@/view/directsell/components/orderitem'
import { DirectSellOrderApi } from '@/api/directsell'
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Card.name]: Card,
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Sticky.name]: Sticky,
        OrderItem
    },
    data() {
        return {
            data: [],
            loading: false,
            finished: false,
            total: 0,
            query: {
                prd_name: null,
                order_state: 100,
                page: 1,
                page_size: 10
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            this.axios.get(DirectSellOrderApi, { params: this.query}).then((ret) => {
                that.loading = false
                if(ret.hasOwnProperty("flag")){
                    toErrorPage(that,'','用户没有关注公众号服务的店铺',null)
                    return
                } else {
                    that.total = ret.count
                    if (ret.results == null || ret.results.length ===0 ) {
                        that.finished = true
                        return
                    }
                    console.log(ret)
                    that.data = that.data.concat(ret.results)
                    if (that.data.length >= that.total) {
                        that.finished = true
                    }
                }
            })
        },
        onLoad() {
            this.query.page = this.query.page + 1
            this.getData()
        },
        goDetail(item) {
            this.$router.push(`/nt/directsellinfo/${item.id}`)
        },
        goback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/home`)
            }
        },
        tabclick(id, title) {
            console.log(title)
            this.data = []
            this.activeName = id
            this.query.page = 1
            this.query.order_state = id
            this.getData()
        }
    }
}
</script>